import React from "react";

/**
 * Pendli "Open Bottom Bay" mark.
 * - Two L-shaped corner brackets on top
 * - Two vertical lines on bottom
 * - Abstract "P" built from two overlapping rectangles
 */
export function LogoMark({ size = 28, color = "#E8A800", accent = "#FF6B00", className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Pendli"
    >
      {/* Top L brackets */}
      <path d="M3 12 L3 3 L12 3" stroke={color} strokeWidth="3" strokeLinecap="square" />
      <path d="M37 12 L37 3 L28 3" stroke={color} strokeWidth="3" strokeLinecap="square" />
      {/* Bottom vertical lines (open bay) */}
      <line x1="3" y1="22" x2="3" y2="37" stroke={color} strokeWidth="3" strokeLinecap="square" />
      <line x1="37" y1="22" x2="37" y2="37" stroke={color} strokeWidth="3" strokeLinecap="square" />
      {/* Abstract P — two overlapping rectangles */}
      <rect x="14" y="11" width="4" height="18" fill={color} />
      <rect x="14" y="11" width="12" height="4" fill={color} />
      <rect x="22" y="11" width="4" height="9" fill={color} />
      <rect x="14" y="16" width="12" height="4" fill={color} />
      {/* Accent dot */}
      <circle cx="32" cy="8" r="1.6" fill={accent} />
    </svg>
  );
}

export function LogoWordmark({ className = "", color = "#F5F0E8" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="pendli-logo">
      <LogoMark size={28} />
      <span
        className="font-display text-xl font-extrabold tracking-tight"
        style={{ color, letterSpacing: "-0.04em" }}
      >
        Pendli
      </span>
    </div>
  );
}
